var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "reply_comment row" }, [
    _c("div", { staticClass: "col-1" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-11" },
      [
        _c("div", { staticClass: "user_label text-center px-0" }, [
          _vm._v(_vm._s(_vm.userNameShort))
        ]),
        _vm._v(" "),
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.reply.aspNetUser &&
                _vm.reply.aspNetUser.firstName +
                  " " +
                  _vm.reply.aspNetUser.lastName
            )
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _vm.readonly || _vm.editReply === null
          ? [
              _c(
                "code",
                {
                  staticClass: "comment_textarea",
                  staticStyle: { "margin-left": "0px" }
                },
                [_vm._v(_vm._s(_vm.reply.text))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "comment_links" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.formatDateTime(_vm.reply.createdOn)) +
                      "\n                "
                  ),
                  !_vm.readonly
                    ? [
                        _vm.userId === _vm.reply.aspNetUserId
                          ? [
                              _vm._v(
                                "\n                        -\n                        "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      _vm.editReply = _vm.reply.text
                                      _vm.$nextTick(() =>
                                        _vm.$refs.editbox.focus()
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("btnEdit")) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _vm._v(
                                "\n                        -\n                        "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.deleteReply.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("btnDelete")))]
                              )
                            ]
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
          : [
              _c("div", { staticClass: "d-flex" }, [
                _c(
                  "div",
                  { staticClass: "mr-1", staticStyle: { flex: "1 1 auto" } },
                  [
                    _c("textarea", {
                      directives: [
                        { name: "autogrow", rawName: "v-autogrow" },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.editReply,
                          expression: "editReply"
                        }
                      ],
                      ref: "editbox",
                      staticClass: "form-control add_comment mb-1",
                      staticStyle: { "overflow-y": "hidden" },
                      attrs: {
                        id: "commentreplyeditbox_" + _vm.reply.id,
                        rows: "1",
                        placeholder: _vm.$t("txtAddComment")
                      },
                      domProps: { value: _vm.editReply },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.editReply = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("text-suggest", {
                      attrs: {
                        textBoxId: "commentreplyeditbox_" + _vm.reply.id,
                        suggestions: _vm.userEmails,
                        trigger: "@"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ml-1", staticStyle: { flex: "0 0 auto" } },
                  [
                    _c("div", { staticClass: "mb-1" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary w-100",
                          attrs: { type: "button" },
                          on: { click: _vm.save }
                        },
                        [_vm._v(_vm._s(_vm.$t("btnSave")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary w-100",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.editReply = null
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("btnCancel")) +
                              "\n                        "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }